module.exports = __webpack_public_path__ + "static/media/ache-mark-munzel.f9ac7475.jpg";